import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import "./Chart.css";
import Stocks from "../../api/Stock";
import Invoices from "../../api/Invoice";

function App() {
  // eslint-disable-next-line
  const month_array = [];
  // eslint-disable-next-line
  const monthWise_data = [];
  // eslint-disable-next-line
  const sale_monthWise_data = [];

  useEffect(() => {
    const HandleReq = async () => {

      // -----------------------  Month Part Start  ---------------------------------

      const currentYear = new Date().getFullYear().toString().substr(-2);
      const monthNew = new Date().getMonth();
      const Months_name = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

      for (let i = 0; i <= monthNew; i++) {
        month_array.push(Months_name[i] + " " + currentYear);
      }

      // -----------------------  Month Part End  --------------------------------
      // ----------------------- Product Data Part Start -------------------------------

      const data = await Stocks.get('/get-total-stocks');
      const data_array = [];

      for (let i = 0; i < (data.data).length; i++) {
        data_array.push(data.data[i].quantity);
      }

      for (let i = 0; i <= monthNew; i++) {
        let monthWise_sum = 0;
        let incre = i + 1;
        let find = '0' + incre;

        let count = 0;
        const new_data = [];
        for (let j = 0; j < (data.data).length; j++) {

          if (data.data[j].month === find) {
            new_data.push(data.data[j].quantity);
            monthWise_sum = monthWise_sum + new_data[count];
            count++;
          }
        }
        monthWise_data.push(monthWise_sum);
      }


      // ----------------------------- Product Data Part End ---------------------------------
      // ----------------------------- Sale Data Part Start -----------------------------------

      const sale_data = await Invoices.get('/get-invoices');

      for (let i = 0; i <= monthNew; i++) {
        let sale_monthWise_sum = 0;
        let incre = i + 1;
        let find = '0' + incre;

        let count = 0;
        const sale_New_data = [];
        for (let j = 0; j < (sale_data.data).length; j++) {

          if (sale_data.data[j].month === find) {
            sale_New_data.push(sale_data.data[j].quantity);
            sale_monthWise_sum = sale_monthWise_sum + sale_New_data[count];
            count++;
          }
        }
        sale_monthWise_data.push(sale_monthWise_sum);
      }
    }
    HandleReq();
  }, [monthWise_data, month_array, sale_monthWise_data]);

  // eslint-disable-next-line
  const [state, setState] = useState({
    options: {
      colors: ["#00E0FF", "#0788FD"],
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: month_array,
        //  categories: ["JAN 22", "FEB 22", "MAR 22", "APR 22", "MAY 22"],
      },
    },
    series: [
      {
        name: "Total Sale", 
        data: sale_monthWise_data,
        // data: [30, 40, 45, 50, 49],
      },
      {
        name: "Total Product",
        data: monthWise_data,
        // data: [3, 60, 35, 80, 49],
      },
      window.dispatchEvent(new Event('resize'))
    ],
  });
  return (
    <div className="chart-div">
      <div className="row">
        <div className="col-4">
          <Chart
            options={state.options}
            series={state.series}
            type="bar"
            width="650"
          />
        </div>
      </div>
    </div>
  );
}

export default App;